import { DraftFullId } from "../../../../Common/CandyApiClient/Types/DraftFullId";
import { RequisitesInfo } from "../Form/IForm";

export function getFakeRequisitesForDraft(
    draftFullId: DraftFullId,
    requisiteList: string[]
): undefined | RequisitesInfo {
    let fakeRequisites: undefined | RequisitesInfo;
    if (process.env.NODE_ENV === "development") {
        const fakeErrorLogString = sessionStorage.getItem("FakeRequisites." + draftFullId.draftId);
        if (fakeErrorLogString != undefined) {
            fakeRequisites = JSON.parse(fakeErrorLogString);
            if (fakeRequisites != undefined) {
                for (const requisiteName of requisiteList.map(x => x.split(".value")[0])) {
                    if (requisiteName != undefined) {
                        if (!Boolean(fakeRequisites[requisiteName])) {
                            fakeRequisites[requisiteName] = { value: "" };
                        }
                    }
                }
            }
        }
    }
    return fakeRequisites;
}

export function setFakeRequisitesForDraft(draftFullId: DraftFullId, requisiteInfo: RequisitesInfo): void {
    if (process.env.NODE_ENV === "development") {
        sessionStorage.setItem("FakeRequisites." + draftFullId.draftId, JSON.stringify(requisiteInfo));
    } else {
        throw new Error("Cannot set fake error log in production build");
    }
}
